import React from "react";
import { Snackbar, Alert } from "@mui/material";

export default function Notification(props) {
  const { notify, setNotify } = props;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  return (
    <Snackbar
      sx={{
        top: (theme) => theme.spacing(9),
        paddingRight: (theme) => theme.spacing(2),
      }}
      open={notify.isOpen}
      autoHideDuration={notify.hide === true ? 10000 : undefined}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert
        sx={{
          userSelect: "text",
          pointerEvents: "auto",
        }}
        severity={notify.type}
        onClose={handleClose}
      >
        <span style={{ userSelect: "text" }}>{notify.message}</span>
      </Alert>
    </Snackbar>
  );
}